const BLOCK = 'animate-pulse bg-[var(--tgui--tertiary_bg_color,rgb(42,42,42))]'

/** Mirrors LotCard geometry exactly so loading -> loaded causes no layout shift. */
export function LotCardSkeleton() {
	return (
		<div className="overflow-hidden rounded-[18px] bg-[var(--tgui--card_bg_color,rgb(50,50,50))]">
			<div className={`aspect-[4/5] ${BLOCK}`} />
			<div className="px-4 pb-4 pt-3.5">
				<div className={`h-[17px] w-2/3 rounded ${BLOCK}`} />
				<div className={`mt-2 h-[13px] w-2/5 rounded ${BLOCK}`} />
				<div className="mt-3.5 flex gap-[7px]">
					<div className={`h-8 w-12 rounded-[9px] ${BLOCK}`} />
					<div className={`h-8 w-12 rounded-[9px] ${BLOCK}`} />
					<div className={`h-8 w-12 rounded-[9px] ${BLOCK}`} />
				</div>
			</div>
		</div>
	)
}
